module.exports = __webpack_public_path__ + "static/media/layer-3-3.c159e9df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scroll/layer-3-3.png
// module id = 425
// module chunks = 0